import { FuctionEvaluateResponseConsultTrx } from ".";
import { encryptAESCBC, decryptAESCBC } from "../cryptoUtils";
import { getOrInitEncryptionKey } from "../../hooks/CryptoHooks";
import fetchData from "../fetchData";
import { defaultParamsError } from "./ConstCustom";

import {
  ErrorCustomApiGateway,
  ErrorCustomApiGatewayTimeout,
  ErrorCustomBackend,
  ErrorCustomBackendPending,
  ErrorCustomFetch,
  ErrorCustomFetchCode,
  ErrorCustomFetchTimeout,
} from "./ExceptionCustom";
import { FuctionEvaluateResponse } from "./FuctionEvaluateCustom";
import { TempErrorFrontService, TempErrorGatewayService } from "./TempCustom";
import { ParamsError, TypingEncryptSetting } from "./TypingCustom";
import { sleep } from "./UtilsCustom";

export const fetchCustomPdpECDH = async (
  url_: string,
  metodo_: "POST" | "PUT" | "GET",
  name_: string,
  id_uuid_trx: string | undefined,
  encrypt_setting_: TypingEncryptSetting | undefined,
  params_: { [key: string]: any } = {},
  body_: { [key: string]: any } = {},
  timeout_: number = 60,
  error_: ParamsError = defaultParamsError,
  functionEvaluateResponse_: Function = FuctionEvaluateResponse,
  ivEncrypt_?: string,
  ivDecrypt_?: string
) => {
  const function_name = "fetchCustomPdpECDH";
  let urlCompleto = url_;

  //armar error_
  try {
    const defaultParamsError_: any = { ...defaultParamsError };
    let assemble_error: any = { ...error_ };
    for (let key in defaultParamsError_) {
      if (assemble_error?.[key] === undefined)
        assemble_error[key] = defaultParamsError_[key];
    }
    error_ = { ...assemble_error };
  } catch (error: any) {
    throw new ErrorCustomFetchCode(
      TempErrorFrontService.replace("%s", name_),
      error.message,
      `${function_name} - armar error_`,
      error_.errorCustomFetchCode?.typeNotify,
      error_.errorCustomFetchCode?.ignoring,
      error_.errorCustomFetchCode?.console_error
    );
  }

  //encriptacion
  let body_request = structuredClone(body_);
  try {
    if (encrypt_setting_?.request_params) {
      if (metodo_ === "GET" || metodo_ === "PUT") {
        if (Object.keys(params_).length > 0) {
          // Obtener la llave de encriptación ECDH
          const encryptionKey = await getOrInitEncryptionKey();

          if (!ivEncrypt_) {
            throw new Error("Se requiere ivEncrypt para encriptar los parámetros");
          }

          const params_request = await encryptAESCBC(
            encryptionKey,
            JSON.stringify(structuredClone(params_)),
            ivEncrypt_
          );
          urlCompleto += `?data=${encodeURIComponent(params_request)}`;
        }
      }
    }

    if (encrypt_setting_?.request_body) {
      if (metodo_ === "POST" || metodo_ === "PUT") {
        if (Object.keys(body_).length > 0) {
          // Obtener la llave de encriptación ECDH
          const encryptionKey = await getOrInitEncryptionKey();

          if (!ivEncrypt_) {
            throw new Error("Se requiere ivEncrypt para encriptar el body");
          }

          body_request = {
            data: await encryptAESCBC(
              encryptionKey,
              JSON.stringify(structuredClone(body_)),
              ivEncrypt_
            ),
          };
        }
      }
    }
  } catch (error: any) {
    throw new ErrorCustomFetchCode(
      TempErrorFrontService.replace("%s", name_),
      error.message,
      `${function_name} - encriptacion`,
      error_.errorCustomFetchCode?.typeNotify,
      error_.errorCustomFetchCode?.ignoring,
      error_.errorCustomFetchCode?.console_error
    );
  }

  //armar parametros
  try {
    if (!encrypt_setting_?.request_params) {
      if (metodo_ === "GET" || metodo_ === "PUT") {
        if (Object.keys(params_).length > 0) {
          let paramsVector = Object.keys(params_);

          paramsVector = paramsVector.map((valueKey) => {
            return `${valueKey}=${params_[valueKey]}`;
          });
          urlCompleto += `?${paramsVector.join("&")}`;
        }
      }
    }
  } catch (error: any) {
    throw new ErrorCustomFetchCode(
      TempErrorFrontService.replace("%s", name_),
      error.message,
      `${function_name} - armar parametros`,
      error_.errorCustomFetchCode?.typeNotify,
      error_.errorCustomFetchCode?.ignoring,
      error_.errorCustomFetchCode?.console_error
    );
  }

  let headers = {};
  if (id_uuid_trx) {
    headers = {
      "X-Custom-Iduuidtrx": id_uuid_trx,
    };
  }

  //Realizar Petición
  let Peticion;
  try {
    const timeout = timeout_ * 1000;
    if (metodo_ === "GET") {
      Peticion = await fetchData(
        urlCompleto,
        "GET",
        {},
        {},
        headers,
        true,
        timeout
      );
    } else if (metodo_ === "PUT") {
      Peticion = await fetchData(
        urlCompleto,
        "PUT",
        {},
        body_request,
        headers,
        true,
        timeout
      );
    } else if (metodo_ === "POST") {
      Peticion = await fetchData(
        urlCompleto,
        "POST",
        {},
        body_request,
        headers,
        true,
        timeout
      );
    }
  } catch (error: any) {
    if (
      error.message === "The user aborted a request." ||
      error.message === "signal is aborted without reason"
    ) {
      throw new ErrorCustomFetchTimeout(
        TempErrorFrontService.replace("%s", name_),
        error.message,
        `${function_name} - Realizar Petición`,
        error_.errorCustomFetchTimeout?.typeNotify,
        error_.errorCustomFetchTimeout?.ignoring,
        error_.errorCustomFetchTimeout?.console_error
      );
    }
    throw new ErrorCustomFetch(
      "ErrorCustomFetch",
      TempErrorFrontService.replace("%s", name_),
      error.message,
      `${function_name} - Realizar Petición`,
      error_.errorCustomFetch?.typeNotify,
      error_.errorCustomFetch?.ignoring ?? true,
      error_.errorCustomFetch?.console_error ?? true
    );
  }
  //Evaluar si la respuesta es json
  try {
    if (typeof Peticion !== "object") {
      throw new ErrorCustomFetchCode(
        TempErrorFrontService.replace("%s", name_),
        "404 not found",
        `${function_name} - Evaluar si la respuesta es json`,
        error_.errorCustomFetchCode?.typeNotify,
        error_.errorCustomFetchCode?.ignoring,
        error_.errorCustomFetchCode?.console_error
      );
    }
  } catch (error) {
    throw error;
  }

  //evaluar respuesta de api gateway
  try {
    if (Peticion?.hasOwnProperty("status") === false) {
      //No es una respuesta directamente del servicio sino del api gateway
      if (Peticion?.hasOwnProperty("message") === true) {
        if (Peticion.message === "Endpoint request timed out") {
          throw new ErrorCustomApiGatewayTimeout(
            TempErrorGatewayService.replace("%s", name_),
            Peticion.message,
            `${function_name} - evaluar respuesta de api gateway`,
            error_.errorCustomApiGatewayTimeout?.typeNotify,
            error_.errorCustomApiGatewayTimeout?.ignoring,
            error_.errorCustomApiGatewayTimeout?.console_error
          );
        } else {
          throw new ErrorCustomApiGateway(
            TempErrorGatewayService.replace("%s", name_),
            Peticion.message,
            `${function_name} - evaluar respuesta de api gateway`,
            error_.errorCustomApiGateway?.typeNotify,
            error_.errorCustomApiGateway?.ignoring,
            error_.errorCustomApiGateway?.console_error
          );
        }
      }
    }
  } catch (error: any) {
    if (
      error instanceof ErrorCustomApiGateway ||
      error instanceof ErrorCustomApiGatewayTimeout
    ) {
      throw error;
    }
    throw new ErrorCustomFetchCode(
      TempErrorFrontService.replace("%s", name_),
      error.message,
      `${function_name} - evaluar respuesta de api gateway`,
      error_.errorCustomFetchCode?.typeNotify,
      error_.errorCustomFetchCode?.ignoring,
      error_.errorCustomFetchCode?.console_error
    );
  }

  //desencriptacion
  let peticion_response = structuredClone(Peticion);
  try {
    if (encrypt_setting_?.response_body) {
      if (!peticion_response?.obj?.data)
        throw new ErrorCustomBackend(
          undefined,
          peticion_response?.msg
            ? peticion_response?.msg
            : TempErrorFrontService.replace(
                "%s",
                `Fallo al desencriptar el servicio ${name_}`
              ),
          `Fallo al desencriptar el servicio ${name_}`,
          `${function_name} - desencriptacion`,
          error_.errorCustomBackend?.typeNotify,
          error_.errorCustomBackend?.ignoring,
          error_.errorCustomBackend?.console_error
        );

      // Obtener la llave de encriptación ECDH
      const encryptionKey = await getOrInitEncryptionKey();

      if (!ivDecrypt_) {
        throw new Error("Se requiere ivDecrypt para desencriptar la respuesta");
      }

      const obj_data_native = await decryptAESCBC(
        encryptionKey,
        peticion_response?.obj?.data,
        ivDecrypt_
      );

      delete peticion_response?.obj?.data;
      peticion_response.obj = {
        ...JSON.parse(obj_data_native),
      };
    }
  } catch (error: any) {
    if (error instanceof ErrorCustomFetch) throw error;

    throw new ErrorCustomFetchCode(
      TempErrorFrontService.replace(
        "%s",
        `Fallo al desencriptar el servicio ${name_}`
      ),
      error.message,
      `${function_name} - desencriptacion`,
      error_.errorCustomFetchCode?.typeNotify,
      error_.errorCustomFetchCode?.ignoring,
      error_.errorCustomFetchCode?.console_error
    );
  }

  //evaluar la respuesta que llega del backend
  try {
    return functionEvaluateResponse_(peticion_response, name_, error_);
  } catch (error) {
    throw error;
  }
};

export const fetchCustomPdpCycleECDH = async (
  url_: string,
  metodo_: "POST" | "PUT" | "GET",
  name_: string,
  id_uuid_trx_: string | undefined,
  encrypt_setting_: TypingEncryptSetting | undefined,
  params_: { [key: string]: any } = {},
  body_: { [key: string]: any } = {},
  retries_: number = 1,
  delayseconds_: number = 5,
  error_: ParamsError = defaultParamsError,
  functionEvaluateResponse_: Function = FuctionEvaluateResponseConsultTrx,
  ivEncrypt_?: string,
  ivDecrypt_?: string
) => {
  const function_name = "fetchCustomPdpCycleECDH";
  try {
    for (let i = 1; i <= retries_; i++) {
      await sleep(delayseconds_);
      try {
        return await fetchCustomPdpECDH(
          url_,
          metodo_,
          name_,
          id_uuid_trx_,
          encrypt_setting_,
          params_,
          body_,
          60,
          error_,
          functionEvaluateResponse_,
          ivEncrypt_,
          ivDecrypt_
        );
      } catch (error: any) {
        if (
          !(error instanceof ErrorCustomBackendPending) &&
          !(error instanceof ErrorCustomApiGatewayTimeout) &&
          !(error instanceof ErrorCustomFetchTimeout)
        ) {
          throw error;
        }
        if (i === retries_) {
          throw error;
        }
      }
    }
  } catch (error: any) {
    if (
      !(error instanceof ErrorCustomFetch) &&
      !(error instanceof ErrorCustomFetchCode)
    ) {
      throw new ErrorCustomFetchCode(
        TempErrorFrontService.replace("%s", name_),
        error.message,
        `${function_name} - fetch de ciclos`,
        error_.errorCustomFetchCode?.typeNotify,
        error_.errorCustomFetchCode?.ignoring,
        error_.errorCustomFetchCode?.console_error
      );
    }
    throw error;
  }
};
